"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressStatus = void 0;
// eslint-disable-next-line import/prefer-default-export
var ProgressStatus;
(function (ProgressStatus) {
    ProgressStatus["NOT_STARTED"] = "not_started";
    ProgressStatus["STARTED"] = "started";
    ProgressStatus["COMPLETED"] = "completed";
})(ProgressStatus = exports.ProgressStatus || (exports.ProgressStatus = {}));
